var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.categories.length
    ? _c("div", { staticClass: "header__shopnav" }, [
        _c("nav", { staticClass: "nav-shop" }, [
          _c(
            "ul",
            { staticClass: "nav-shop__list" },
            [
              _vm.showPersonalStartpage
                ? _c(
                    "li",
                    { staticClass: "nav-shop__item nav-shop__item--icon" },
                    [
                      _c(
                        "a",
                        {
                          staticClass:
                            "nav-shop__item-link nav-shop__item-link--icon",
                          class: {
                            "nav-shop__item-link--active":
                              _vm.activeCategory == _vm.favoriteCode,
                          },
                          attrs: { title: _vm.$t("shoplist.favorites.title") },
                          on: { click: _vm.onFavoriteProducts },
                        },
                        [
                          _vm.activeCategory == _vm.favoriteCode
                            ? _c("SVGHeartFull", {
                                staticClass: "nav-shop__item-icon",
                              })
                            : _c("SVGHeart", {
                                staticClass: "nav-shop__item-icon",
                              }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.categories, function (category) {
                return _c(
                  "li",
                  { key: category.code, staticClass: "nav-shop__item" },
                  [
                    _c("a", {
                      staticClass: "nav-shop__item-link",
                      class: {
                        "nav-shop__item-link--active":
                          _vm.activeCategory == category.code,
                      },
                      domProps: { innerHTML: _vm._s(category.name) },
                      on: {
                        click: function ($event) {
                          return _vm.onChangeCategory(category)
                        },
                      },
                    }),
                  ]
                )
              }),
            ],
            2
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }